import { render, staticRenderFns } from "./ShowAssessment.vue?vue&type=template&id=6b47b36e&scoped=true&"
import script from "./ShowAssessment.vue?vue&type=script&lang=js&"
export * from "./ShowAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b47b36e",
  null
  
)

/* custom blocks */
import block0 from "./ShowAssessment.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports